import {format_currency_with_decimal} from "./function";

export default {
  install(Vue) {
    Vue.directive('dashed', {
      inserted: function (el) {
        el.style.setProperty('border-style', 'dashed', 'important')
      }
    })

    Vue.directive('revert', {
      inserted: function (el) {
        const style = window.getComputedStyle(el)
        const color = style.backgroundColor
        const bg_color = style.color

        el.style.setProperty('background-color', bg_color, 'important')
        el.style.setProperty('color', color, 'important')
        for (const child of el.children) {
          child.style.setProperty('color', color, 'important')
          child.style.setProperty('font-weight', 'bold', 'important')
        }
      }
    })

    Vue.directive('currency', {
      bind: function (el) {
        if (el.value) {
          el.addEventListener('focus', () => {
            el.value = el.value.replace(/,/g, '')
          });

          el.addEventListener('blur', () => {
            el.value = value.replace(/\D/g, '')
            el.value = format_currency_with_decimal(el.value)
          });
        }
      },
      update: function (el, binding) {
        if (el !== document.activeElement) {
          if (el.value && !Number.isNaN(el.value)) {
            el.value = value.replace(/\D/g, '')
            el.value = format_currency_with_decimal(el.value)
          }
        }
      },
      unbind(el) {
      }
    })

    Vue.directive('number-format', {
      bind(el) {
        const inputEl = el.tagName === 'INPUT' ? el : el.querySelector('input');
        if (!inputEl) return;

        const formatNumber = (value) => {
          if (!value || isNaN(value)) return value;
          return parseFloat(value).toLocaleString('en-US');
        };

        const parseNumber = (value) => value.replace(/,/g, '');

        const onFocus = () => {
          inputEl.value = parseNumber(inputEl.value);
        };

        const onBlur = () => {
          inputEl.value = formatNumber(inputEl.value);
        };

        // Gắn sự kiện
        inputEl.addEventListener('focus', onFocus);
        inputEl.addEventListener('blur', onBlur);

        // Format lần đầu hiển thị
        setTimeout(() => {
          inputEl.value = formatNumber(inputEl.value);
        });

        // Lưu lại để cleanup
        inputEl.__numberFormat__ = {
          onFocus,
          onBlur
        };
      },
      unbind(el) {
        const inputEl = el.tagName === 'INPUT' ? el : el.querySelector('input');
        if (!inputEl || !inputEl.__numberFormat__) return;

        const {
          onFocus,
          onBlur
        } = inputEl.__numberFormat__;
        inputEl.removeEventListener('focus', onFocus);
        inputEl.removeEventListener('blur', onBlur);
        delete inputEl.__numberFormat__;
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/addon/directive.js